<div class="popup-header">
  <div class="title">
    {{data.orderId}}
  </div>
</div>

<div mat-dialog-content>
  <br>
  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">Order No</span>
    </div>
    <input type="text" class="form-control" aria-label="Small" [(ngModel)]="data.orderId" [disabled]="editable"
      aria-describedby="inputGroup-sizing-sm">
  </div>

  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">Date</span>
    </div>
    <input type="text" class="form-control" aria-label="Small" [(ngModel)]="data.orderDate" [disabled]="editable"
      aria-describedby="inputGroup-sizing-sm">
  </div>
  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">Order Status</span>
    </div>
    <input type="text" class="form-control" aria-label="Small" [(ngModel)]="data.status" [disabled]="editable"
      aria-describedby="inputGroup-sizing-sm">
  </div>

  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">Payment Type</span>
    </div>
    <input type="text" class="form-control" aria-label="Small" [(ngModel)]="data.pay" [disabled]="editable"
      aria-describedby="inputGroup-sizing-sm">
  </div>

  <div class="input-group  mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text" id="inputGroup-sizing-sm">Payment Status</span>
    </div>
    <input type="text" class="form-control" aria-label="Small" [(ngModel)]="data.paymentStatus" [disabled]="editable"
      aria-describedby="inputGroup-sizing-sm">
  </div>

  <div class="input-group  mb-3" *ngIf="data.cardLast4">
    <div class="input-group-prepend">
      <span class="input-group-text">Card</span>
    </div>
    <input type="text" class="form-control" [value]="cardText" disabled title="The paying card as Stripe reports it">
  </div>


  <div class="input-group  mb-3">
    <mat-list>
      <div class="input-group-prepend">
        <span class="input-group-text " id="">Product Details</span>
      </div>
      <!-- <div mat-subheader>Folders</div> -->
      <mat-list-item *ngFor="let folder of orderDetail">

        <!-- <mat-icon mat-list-icon>fastfood</mat-icon> -->
        <div matListItemTitle>{{folder.name}}  x  {{folder.num}} ({{ folder.detailPrice}}kr)</div>
        <div matListItemLine>   
          <span  *ngIf="isArray(folder.status)">
            <span *ngFor="let data of folder.status"> {{data.value}} </span>
          </span>
          <span matListItemLine *ngIf="!isArray(folder.status)">
            <span> {{folder.status}} </span>
          </span>
        </div>
        <!-- {{folder.status | json}} -->
        
        
        <!-- <divmatListItemLine > {{folder.status}} </div> -->
        <mat-divider [inset]="true"></mat-divider>
      </mat-list-item>
    </mat-list>
  </div>

  <div class="input-group  mb-3">
    <mat-list>
      <div class="input-group-prepend">
        <span class="input-group-text " id="">Order Transistion</span>
      </div>
      <!-- <div mat-subheader>Folders</div> -->
      <mat-list-item *ngFor="let folder of data.transitions">
        <!-- <mat-icon mat-list-icon>folder</mat-icon> -->
        <div matListItemTitle>{{folder.message}} </div>
        <div matListItemLine> {{folder.date.toDate() | date:'yyyy/MM/dd h:mm:ss a'}} </div>
        <mat-divider [inset]="true"></mat-divider>
      </mat-list-item>
    </mat-list>

    
  </div>

  <div class="input-group  mb-3">
    <mat-list>
      <div class="input-group-prepend">
        <span class="input-group-text " id="">Support Transistion</span>
      </div>
      <!-- <div mat-subheader>Folders</div> -->
      <mat-list-item *ngFor="let folder of supportMessages">
        <!-- <mat-icon mat-list-icon>folder</mat-icon> -->
          <div matListItemTitle class="support-message-title">{{folder.message}}</div>
        <div matListItemLine>  {{folder.email}} • {{folder.date.toDate() | date:'yyyy/MM/dd h:mm:ss a'}} </div>
        <mat-divider [inset]="true"></mat-divider>
      </mat-list-item>
    </mat-list> 
  </div> 
  <div class="input-group  mb-3">
    <mat-list>
      <div class="input-group-prepend">
        <span class="input-group-text " id="">Log Transistion</span>
      </div>
      <!-- <div mat-subheader>Folders</div> -->
      <mat-list-item *ngFor="let folder of data.logTransitions">
        <!-- <mat-icon mat-list-icon>folder</mat-icon> -->
        <div matListItemTitle>{{folder.message}} </div>
        <div matListItemLine> {{folder.date.toDate() | date:'yyyy/MM/dd h:mm:ss a'}} </div>
        <mat-divider [inset]="true"></mat-divider>
      </mat-list-item>
    </mat-list>
  </div>

</div>
<div mat-dialog-actions align="end">
  <button class="theme-button" (click)="refundPayment()"[disabled]="!canRefund" *ngIf="canRefund">Refund</button>
  <button class="theme-button" (click)="onNoClick()">Close</button>
</div>
